import type { FC } from 'react';

import {
  Divider,
  Header,
  PrimaryButton,
  Spacer,
  TertiaryButton,
  Text,
  Toolbar,
} from '@procurify/ui'
import { useIntl } from 'react-intl'

import ErrorCSVIcon from './assets/import-csv-error.png'
import { IMPORTER_ERROR_CODES } from '../../constants'
import messages from '../../messages'
import { ImporterContentStyled as Content } from '../../styles/ImporterContentStyled'

export interface ILegacyImporterFileErrorStageProps {
  errorType?: string
  numRequiredFields?: number
  onGoToUpload?: () => void
  onDismiss?: () => void
}

export const LegacyImporterFileErrorStage: FC<
  ILegacyImporterFileErrorStageProps
> = ({ errorType, onGoToUpload, onDismiss, numRequiredFields = 0 }) => {
  const intl = useIntl()

  return (
    <Content>
      <Spacer />

      <img
        src={ErrorCSVIcon}
        alt={intl.formatMessage(messages.errorImageLabel)}
      />
      <Header as='h3' gutter>
        {errorType === IMPORTER_ERROR_CODES.EMPTY_CSV
          ? intl.formatMessage(messages.emptyErrorStepTitle)
          : intl.formatMessage(messages.genericErrorStepTitle)}
      </Header>

      <Text>
        {errorType === IMPORTER_ERROR_CODES.INCOMPLETE
          ? intl.formatMessage(messages.incompleteErrorStepDescription, {
              minColumns: numRequiredFields,
            })
          : intl.formatMessage(messages.genericErrorStepDescription)}
      </Text>

      <Divider space={2} />

      <Toolbar>
        <Toolbar.Fill />
        <Toolbar.Item>
          <TertiaryButton onClick={onDismiss}>
            {intl.formatMessage(messages.errorStepCancelButton)}
          </TertiaryButton>
          <PrimaryButton onClick={onGoToUpload}>
            {intl.formatMessage(messages.errorStepGoBackToUpload)}
          </PrimaryButton>
        </Toolbar.Item>
      </Toolbar>
    </Content>
  )
}
